import React, {memo} from "react";

export const IconUploadContract = memo(({color, width, height, addClass}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      className={addClass}
    >
      <path
        d="M18 17.7501H2C1.173 17.7501 0.5 17.0771 0.5 16.2501V14.2501C0.5 13.9741 0.724 13.7501 1 13.7501C1.276 13.7501 1.5 13.9741 1.5 14.2501V16.2501C1.5 16.5261 1.724 16.7501 2 16.7501H18C18.276 16.7501 18.5 16.5261 18.5 16.2501V14.2501C18.5 13.9741 18.724 13.7501 19 13.7501C19.276 13.7501 19.5 13.9741 19.5 14.2501V16.2501C19.5 17.0771 18.827 17.7501 18 17.7501Z"
        fill={color || "black"}
      />
      <path
        d="M15.3542 7.39613L10.3542 2.39613C10.1592 2.20113 9.84223 2.20113 9.64723 2.39613L4.64723 7.39613C4.45223 7.59113 4.45223 7.90813 4.64723 8.10313C4.84223 8.29813 5.15923 8.29813 5.35423 8.10313L9.50023 3.95713V14.2501C9.50023 14.5261 9.72423 14.7501 10.0002 14.7501C10.2762 14.7501 10.5002 14.5261 10.5002 14.2501V3.95713L14.6462 8.10313C14.7442 8.20113 14.8722 8.24913 15.0002 8.24913C15.1282 8.24913 15.2562 8.20013 15.3542 8.10313C15.5492 7.90813 15.5492 7.59113 15.3542 7.39613Z"
        fill={color || "black"}
      />
    </svg>
  );
});
